import type { CloudBluePlan } from "@gatsby-plugin-definitions/fragments/CloudBluePlan"
import type { SaleConfiguration } from "~/fragments/saleConfigurations"

type UpsellItem = NonNullable<SaleConfiguration["flatData"]["upsell"]>[number]

export function isCloudBluePlanUpsell(
  upsellItem: UpsellItem
): upsellItem is CloudBluePlan {
  return "flatData" in upsellItem && "alias" in upsellItem.flatData
}
